import React, { Fragment } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "lodash";
import NProgress from "nprogress";
import { Helmet } from "react-helmet";

import PublicLayout from "./Public";
import AuthLayout from "./Auth";
import MainLayout from "./Main";

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
};

let previousPath = "";

const Layout = (props) => {
  const {
    children,
    location: { pathname, search },
  } = props;

  const user = useSelector((state) => state.user);
  const { subdomain } = useSelector((state) => state.settings);

  // NProgress & ScrollTop Management
  const currentPath = pathname + search;
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0);
    NProgress.start();
  }
  setTimeout(() => {
    NProgress.done();
    previousPath = currentPath;
  }, 300);

  // Layout Rendering
  const getLayout = () => {
    if (pathname === "/") {
      return "public";
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return "auth";
    }
    return "main";
  };

  const Container = Layouts[getLayout()];
  const isUserAuthorized = user.authorized;
  const isUserLoading = user.loading;
  const isAuthLayout = getLayout() === "auth";

  const BootstrappedLayout = () => {
    if (isUserLoading) {
      return null;
    }

    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null;
    }
    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      return <Redirect to="/auth/login" />;
    }
    if (isUserAuthorized && pathname === "/auth/login") {
      return <Redirect to="/" />;
    }
    // in other case render previously set layout
    return <Container>{children}</Container>;
  };

  return (
    <Fragment>
      <Helmet titleTemplate="Waave | %s" title={capitalize(subdomain)} />
      {BootstrappedLayout()}
    </Fragment>
  );
};

export default withRouter(Layout);
